<template>
  <div class="footer-wrap">
    <div class="footer-content">
      <div class="copyright">
        <div @click="openurl('/')">
          <!-- <img src="@/assets/img/home-icon.png" width="16px" alt=""> -->
          <i class="iconfont icon-home1" :style="{ color: color2 }"></i
          ><span :style="{ color: color2 }">主页</span>
        </div>
        <div @click="openurl('/contact')">
          <!-- <img src="@/assets/img/email-icon.png" width="16px" alt=""> -->
          <i class="iconfont icon-email" :style="{ color: color2 }"></i
          ><span :style="{ color: color2 }">联系我们</span>
        </div>
        <div class="foot-login" v-if="!login" @click="openLogin">
          <!-- <img src="@/assets/img/cp-icon.png" width="16px" alt=""> -->
          <i class="iconfont icon-diannao" :style="{ color: color2 }"></i
          ><span :style="{ color: color2 }">登录</span>
        </div>
        <div class="foot-register" v-if="!login" @click="openRegister">
          <!-- <img src="@/assets/img/write-icon.png" width="16px" alt=""> -->
          <i class="iconfont icon-register" :style="{ color: color2 }"></i
          ><span :style="{ color: color2 }">注册</span>
        </div>
        <div class="foot-login" v-if="login" @click="logout">
          <!-- <img src="@/assets/img/cp-icon.png" width="16px" alt=""> -->
          <i class="iconfont icon-tuichudenglu" :style="{ color: color2 }"></i
          ><span :style="{ color: color2 }">退出</span>
        </div>
        
        <div class="center-line" :style="{ color: color2 }">|</div>
        <div v-for="(item, index) in serviceList" :key="'foot-' + index">
          <span :style="{ color: color2 }" @click="showMessage(item)">{{
            item.title
          }}</span>
        </div>
      </div>
    </div>
    <div class="footer-content">
      <!-- <div class="contact-us">
          <span @click="openurl('/')">主页</span>
          <span @click="openurl('/contact')">联系我们</span>
          <span class="foot-login" v-if="!login" @click="openLogin">登录</span>
          <span class="foot-register" v-if="!login" @click="openRegister">注册</span>
          <span v-if="login" @click="logout">退出</span>
        </div> -->
      <div class="copyright">
        
        <div :style="{ color: color }">
            <a
              class="beian-a"
              href="https://beian.miit.gov.cn/"
              target="_blank"
              :style="{color: color}"
              >ICP备案编号：粤ICP备06005996号-3</a>
              <img src="@/assets/img/备案图标.png" width="20px" alt="">
              &nbsp;
              <a class="beian-a" href="https://beian.mps.gov.cn/#/query/webSearch?code=44011202003072" :style="{color: color}" rel="noreferrer" target="_blank">粤公网安备44011202003072号</a>

          生态环境部华南环境科学研究所Copyright ◎ 2024
          技术支持:杭州蚁图科技有限公司
        </div>
        
        
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/login";
import notice from "@/api/notice";
export default {
  name: "FooterVue",
  data() {
    return {
      name: "",
      token: "",
      serviceList: [],
    };
  },
  props: {
    loginData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    login: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "#000",
    },
    color2: {
      type: String,
      default: "#69FFF8",
    },
  },
  methods: {
    showMessage(item) {
      this.$emit("openMessageBoxWrap", item);
    },
    getServiceList() {
      notice.openwebtermsofserviceList().then((res) => {
        if (res.code === 0) {
          this.serviceList = res.data;
          console.log(this.serviceList);
        }
      });
    },
    openLogin() {
      this.$emit("openLogin");
    },
    openRegister() {
      this.$emit("openRegister");
    },
    logout() {
      this.$confirm("请确认，退出登录！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.doLoginOut("退出成功");
        })
        .catch(() => {
          this.$message({
            message: "已取消",
          });
        });
    },
    doLoginOut(message) {
      api
        .logout()
        .then((res) => {
          if (res.code === 0) {
            this.$message({
              message: message,
              type: "success",
            });
            sessionStorage.removeItem("login");
            sessionStorage.removeItem("name");
            sessionStorage.removeItem("token");
            if (this.$router.history.current.fullPath !== "/") {
              this.$emit("loginOut");
              this.$router.push({
                path: "/",
              });
            } else {
              this.$emit("loginOut");
            }
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openurl(url) {
      if (this.$router.history.current.fullPath === url) {
        this.$router.go(0);
      } else {
        this.$router.push(url);
      }
    },
  },
  watch: {
    loginData: {
      handler(newValue) {
        if (newValue) {
          this.name = newValue.username;
          this.token = newValue.token;
        }
      },
    },
  },
  created() {
    this.getServiceList();
  },
};
</script>

<style lang="scss" scoped>
.footer-wrap {
  height: 46px;
  .footer-content {
    height: 23px;
    
    .contact-us {
      padding: 0 30px;
      span {
        display: inline-block;
        margin-right: 20px;
        color: #00a8ff;
        cursor: pointer;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE/Edge */
        user-select: none; /* 标准语法 */
        &:hover {
          color: #00b7ff;
        }
        &:active {
          color: #409eff;
        }
      }
    }
.beian-a{
  text-decoration: none;margin-right: 10px
}

    .copyright {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      width: 100%;
      & > div {
        margin-right: 20px;
        height: 23px;
        line-height: 23px;
        display: flex;
        align-items: center;
        cursor: pointer;
        span {
          font-size: 12px;
          color: #69fff8;
        }
        img {
          // vertical-align: sub;
        }
      }
      .center-line {
        cursor: default;
      }

    }

    
  }
}
</style>